import { Box } from "@chakra-ui/react";
import React from "react";

import Chapter from "../components/Chapter";
const ChapterScreen = () => {
  return (
    <Box>
      <Chapter />
    </Box>
  );
};

export default ChapterScreen;
